import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import { conformityDetailsValidationSchema, VehicleConformityDetailsDto } from 'dtos/vehicles/conformity/index'
import { Form, Formik } from 'formik'

interface EditConformityDetailsDialogProps {
  initialValues?: VehicleConformityDetailsDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: VehicleConformityDetailsDto) => void
  open: boolean
}

export default function EditConformityDetailsDialog({ initialValues, isLoading, onClose, onSave, open }: EditConformityDetailsDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues ?? {}}
        onSubmit={values => {
          onSave(values)
        }}
        validateOnBlur
        validateOnChange
        validationSchema={conformityDetailsValidationSchema}
      >
        {({ errors, handleBlur, handleChange, touched, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Edit Conformity Details</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading}
                      error={Boolean(touched.conformityPackageTrackingNumber && errors.conformityPackageTrackingNumber)}
                      fullWidth
                      helperText={touched.conformityPackageTrackingNumber && errors.conformityPackageTrackingNumber}
                      label='Conformity Package Tracking #'
                      name='conformityPackageTrackingNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='text'
                      value={values.conformityPackageTrackingNumber ?? ''}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**Conformity Package Tracking # Field:**

 A free-text field to edit the Conformity Package Tracking Number.

 This field is required.

 **CANCEL Button:**

 Clicking the CANCEL button will close the dialog and not save any changes.

 **SAVE Button:**
 
 Clicking the SAVE button will save any changes.`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
